<template>
  <div>
    <app-collapse-item
      v-for="item in list"
      :key="item.id"
    >
      <template #header>
        <span class=""><strong class="text-primary">{{
          $moment(item.datetime)
            .format('LT')
        }}</strong> &nbsp; {{
          (item.expedition_sheets ?? []).length
        }} {{ $t('therms.expedition_sheets') }}
        </span></template>

      <table>
        <tr>
          <td class="pb-1">
            <strong>{{ $t('therms.external_id') }} :</strong>
          </td>
          <td class="pb-1">
            {{ item.external_id }}
          </td>
        </tr>
        <tr v-if="hasMultipleFarmers">
          <td
            class="pb-1"
            style="vertical-align: top;"
          >
            <strong>{{ $t('therms.farmers') }} :</strong>
          </td>
          <td class="pb-1">
            {{
              item.farmers.map(e => e.name)
                .sort((a, b) => a.localeCompare(b))
                .join(', ')
            }}
          </td>
        </tr>
        <tr v-if="item.account">
          <td>
            <strong>{{ $t('therms.account') }} :</strong>
          </td>
          <td>
            {{ item.account.name }}
          </td>
        </tr>
        <tr v-if="item.account_shipping_address">
          <td
            style="vertical-align: top;"
          ><strong>{{ $t('therms.account_shipping_address') }} :</strong></td>
          <td>
            {{ item.account_shipping_address?.complete_address ?? '-' }}
          </td>
        </tr>
        <tr v-if="item.carrier">
          <td class="pt-1">
            <strong>{{ $t('therms.carrier') }} :</strong>
          </td>
          <td class="pt-1">
            {{ item.carrier.name }}
          </td>
        </tr>
        <tr v-if="item.expedition_sheets && (item?.expedition_sheets ?? []).length >=1">
          <td
            class="pt-1"
            style="vertical-align: top;"
          >
            <strong>{{ $t('therms.expedition_sheets') }} :</strong>
          </td>
          <td class="pt-1">
            <div style="display: flex; flex-wrap: wrap; gap: 0.5em;">

              <template v-for="expedition_sheet in item.expedition_sheets">
                <a
                  :key="expedition_sheet.id"
                  target="_blank"
                  :href="expedition_sheet.pdf_url"
                  class="badge badge-light-primary"
                >
                  {{ expedition_sheet.external_id }}
                </a>
              </template>
            </div>
          </td>
        </tr>
        <tr v-if="item.delivery_sheets && (item?.delivery_sheets ?? []).length >=1">
          <td
            class="pt-1"
            style="vertical-align: top;"
          >
            <strong>{{ $t('therms.delivery_sheets') }} :</strong>
          </td>
          <td class="pt-1">
            <div style="display: flex; flex-wrap: wrap; gap: 0.5em;">

              <template v-for="delivery_sheet in item.delivery_sheets">
                <a
                  :key="delivery_sheet.id"
                  target="_blank"
                  :href="delivery_sheet.pdf_url"
                  class="badge badge-light-primary"
                >
                  {{ delivery_sheet.external_id }}
                </a>
              </template>
            </div>
          </td>
        </tr>
        <tr>
          <td class="pt-1">
            <strong>{{ $t('therms.status') }} :</strong>
          </td>
          <td class="pt-1">
            <b-badge :variant="status[1][item.is_valid ? 1 : 0]">
              {{ status[0][item.is_valid ? 1 : 0] }}
            </b-badge>
          </td>
        </tr>
      </table>
    </app-collapse-item>
  </div>
</template>
<script>
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import { mapGetters } from 'vuex'
import { BBadge } from 'bootstrap-vue'

export default {
  name: 'AppCollapseExpeditionSheet',
  components: {
    BBadge,
    AppCollapseItem,
  },
  props: {
    list: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      hasMultipleFarmers: 'farmers/hasMultipleFarmers',
    }),
    status() {
      return [
        {
          1: this.$t('therms.shipped'),
          0: this.$t('therms.canceled'),
        },
        {
          1: 'light-success',
          0: 'light-danger',
        },
      ]
    },
  },
  methods: {
  },
}
</script>
<style lang="scss" scoped>
@import '@core/scss/base/bootstrap-extended/_include';
@import '@core/scss/base/components/_include';

table tr td:nth-child(2) {
  padding-left: 20px;
}

</style>
